/* AVADACHI product card actions
   - Bag icon on every product photo: tap it, pick a size, it goes straight into the cart drawer.
     Products with more than one colour open the theme quick-add pop-up instead.
   - Heart icon on every product photo + product page: saves to a wishlist (stored in this browser),
     with a heart link in the header and a /pages/wishlist page that lists saved items. */
(function () {
  var SIZE_NAME = /^(size|sizes)$/i;
  var WL_KEY = 'avd_wishlist';
  var cache = {};

  /* ---------- helpers ---------- */
  function handleFromUrl(url) {
    var m = (url || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function getProduct(handle) {
    if (!cache[handle]) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
    }
    return cache[handle];
  }
  function optionName(o) { return typeof o === 'string' ? o : o && o.name; }
  function optionValues(o) { return (o && o.values) || []; }
  function sizeIndex(product) {
    var opts = product.options || [];
    var idx = -1;
    opts.forEach(function (o, i) { if (SIZE_NAME.test(optionName(o) || '')) idx = i; });
    if (idx === -1) {
      // single-variant product: treat as "one size"
      return product.variants && product.variants.length === 1 ? -2 : -1;
    }
    for (var j = 0; j < opts.length; j++) {
      if (j !== idx && optionValues(opts[j]).length > 1) return -1;
    }
    return idx;
  }
  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
    try { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function stop(e) { e.preventDefault(); e.stopPropagation(); }

  var ICON_BAG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 8h12l-1 12H7L6 8z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg><span class="avd-ca__plus" aria-hidden="true">+</span>';
  var ICON_HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.3s-7.3-4.4-9.2-9A4.9 4.9 0 0 1 12 6.4a4.9 4.9 0 0 1 9.2 4.9c-1.9 4.6-9.2 9-9.2 9z" fill="var(--avd-heart-fill, none)" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>';

  /* ---------- wishlist ---------- */
  function wlRead() {
    try { var v = JSON.parse(window.localStorage.getItem(WL_KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function wlWrite(list) {
    try { window.localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) { /* storage blocked */ }
    wlSync();
  }
  function wlHas(handle) { return wlRead().indexOf(handle) !== -1; }
  function wlToggle(handle) {
    var list = wlRead();
    var i = list.indexOf(handle);
    if (i === -1) list.unshift(handle); else list.splice(i, 1);
    wlWrite(list);
    return i === -1;
  }
  function wlSync() {
    var list = wlRead();
    document.querySelectorAll('[data-avd-wl]').forEach(function (b) {
      var on = list.indexOf(b.dataset.avdWl) !== -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = b.querySelector('.avd-wl-pdp__label');
      if (label) label.textContent = on ? 'Saved' : 'Save';
    });
    document.querySelectorAll('.avd-wl-header__count').forEach(function (c) {
      c.textContent = list.length;
      c.hidden = list.length === 0;
    });
  }
  function heartButton(handle, title, cls) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.dataset.avdWl = handle;
    b.setAttribute('aria-label', 'Save ' + (title || 'this product') + ' to wishlist');
    b.innerHTML = ICON_HEART;
    b.addEventListener('click', function (e) {
      stop(e);
      var added = wlToggle(handle);
      b.classList.remove('is-pop'); void b.offsetWidth; if (added) b.classList.add('is-pop');
    });
    return b;
  }

  /* ---------- cart ---------- */
  function cartTarget() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }
  function addToCart(variantId, btn, msgEl, done) {
    var target = cartTarget();
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', 1);
    if (target && typeof target.getSectionsToRender === 'function') {
      fd.append('sections', target.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
      if (typeof target.setActiveElement === 'function') target.setActiveElement(btn);
    }
    btn.classList.add('is-loading');
    if (msgEl) msgEl.textContent = '';
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (res.status) {
          if (msgEl) msgEl.textContent = res.description || res.message || 'Could not add to cart';
          return;
        }
        if (done) done();
        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'avadachi-card-actions', productVariantId: variantId, cartData: res });
        }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        if (target && typeof target.renderContents === 'function' && res.sections) {
          target.renderContents(res);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        if (msgEl) msgEl.textContent = 'Could not add to cart. Please try again.';
      });
  }

  /* ---------- card actions ---------- */
  function closeAllPanels(except) {
    document.querySelectorAll('.avd-ca__panel.is-open').forEach(function (p) {
      if (p !== except) {
        p.classList.remove('is-open');
        var host = p.closest('[data-avd-ca]');
        var bag = host && host.querySelector('.avd-ca__bag');
        if (bag) bag.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function buildPanel(product, host, bag) {
    var si = sizeIndex(product);
    var panel = document.createElement('div');
    panel.className = 'avd-ca__panel';
    panel.innerHTML =
      '<div class="avd-ca__panel-head"><span>Select size</span>' +
      '<button type="button" class="avd-ca__close" aria-label="Close">&times;</button></div>' +
      '<div class="avd-ca__sizes" role="group"></div>' +
      '<p class="avd-ca__msg" role="status" aria-live="polite"></p>';
    panel.querySelector('.avd-ca__sizes').setAttribute('aria-label', 'Add ' + product.title + ' to cart');
    var row = panel.querySelector('.avd-ca__sizes');
    var msg = panel.querySelector('.avd-ca__msg');
    var key = si >= 0 ? 'option' + (si + 1) : null;
    var seen = {};

    product.variants.forEach(function (v) {
      var size = key ? v[key] : 'One size';
      if (!size || seen[size]) return;
      seen[size] = true;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'avd-ca__size';
      b.textContent = size;
      if (v.available) {
        b.setAttribute('aria-label', 'Add size ' + size + ' to cart');
        b.addEventListener('click', function (e) {
          stop(e);
          addToCart(v.id, b, msg, function () {
            b.classList.add('is-added');
            setTimeout(function () { panel.classList.remove('is-open'); bag.setAttribute('aria-expanded', 'false'); b.classList.remove('is-added'); }, 700);
          });
        });
      } else {
        b.disabled = true;
        b.classList.add('is-soldout');
        b.setAttribute('aria-label', 'Size ' + size + ' sold out');
      }
      row.appendChild(b);
    });

    panel.querySelector('.avd-ca__close').addEventListener('click', function (e) {
      stop(e);
      panel.classList.remove('is-open');
      bag.setAttribute('aria-expanded', 'false');
      bag.focus();
    });
    panel.addEventListener('click', function (e) { e.stopPropagation(); if (e.target === panel) e.preventDefault(); });
    host.appendChild(panel);
    return panel;
  }

  function decorate(host, url, card) {
    if (host.dataset.avdCa) return;
    var handle = handleFromUrl(url);
    if (!handle) return;
    host.dataset.avdCa = handle;

    var titleEl = card && (card.querySelector('.card__heading a, .avd-card__title') || card.querySelector('.card__heading'));
    var title = titleEl ? titleEl.textContent.trim() : '';

    var wrap = document.createElement('div');
    wrap.className = 'avd-ca';
    wrap.appendChild(heartButton(handle, title, 'avd-ca__btn avd-ca__heart'));

    var bag = document.createElement('button');
    bag.type = 'button';
    bag.className = 'avd-ca__btn avd-ca__bag';
    bag.setAttribute('aria-label', 'Quick add ' + (title || 'this product') + ' to cart');
    bag.setAttribute('aria-expanded', 'false');
    bag.innerHTML = ICON_BAG;
    wrap.appendChild(bag);
    host.appendChild(wrap);

    var panel = null;
    bag.addEventListener('click', function (e) {
      stop(e);
      getProduct(handle).then(function (p) {
        if (!p.available) { bag.classList.add('is-soldout'); return; }
        var si = sizeIndex(p);
        if (si === -1) {
          // several colours: use the theme's quick-add pop-up if the card has one, else open the product
          var opener = card && card.querySelector('.quick-add modal-opener button, .quick-add button[data-product-url]');
          if (opener) opener.click(); else window.location.href = p.url || url;
          return;
        }
        if (!panel) panel = buildPanel(p, host, bag);
        var open = !panel.classList.contains('is-open');
        closeAllPanels(panel);
        panel.classList.toggle('is-open', open);
        bag.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var first = panel.querySelector('.avd-ca__size:not([disabled])'); if (first) first.focus({ preventScroll: true }); }
      }).catch(function () { window.location.href = url; });
    });

    // hide the bag straight away for sold-out products
    getProduct(handle).then(function (p) { if (!p.available) wrap.classList.add('is-soldout'); }).catch(function () {});
  }

  function scanCards(root) {
    // Theme product cards (collections, Shop All, related products, search)
    (root || document).querySelectorAll('.card-wrapper').forEach(function (card) {
      var inner = card.querySelector('.card__inner');
      var link = card.querySelector('a[href*="/products/"]');
      if (!inner || !link || !card.querySelector('.card__media')) return;
      decorate(inner, link.getAttribute('href'), card);
    });
    // Homepage "Drop 03" cards
    (root || document).querySelectorAll('a.avd-card').forEach(function (a) {
      var media = a.querySelector('.avd-card__media');
      if (media) decorate(media, a.getAttribute('href'), a);
    });
  }

  /* ---------- header heart + product page heart ---------- */
  function headerHeart() {
    if (document.querySelector('.avd-wl-header')) return;
    var cart = document.getElementById('cart-icon-bubble');
    if (!cart || !cart.parentNode) return;
    var a = document.createElement('a');
    a.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'pages/wishlist';
    a.className = 'header__icon link focus-inset avd-wl-header';
    a.setAttribute('aria-label', 'Wishlist');
    a.innerHTML = ICON_HEART + '<span class="avd-wl-header__count" hidden>0</span>';
    cart.parentNode.insertBefore(a, cart);
  }
  function productHeart() {
    if (document.querySelector('.avd-wl-pdp')) return;
    var handle = handleFromUrl(window.location.pathname);
    var titleWrap = document.querySelector('.product__info-container .product__title');
    if (!handle || !titleWrap) return;
    var h1 = titleWrap.querySelector('h1');
    var b = heartButton(handle, h1 ? h1.textContent.trim() : '', 'avd-wl-pdp');
    b.insertAdjacentHTML('beforeend', '<span class="avd-wl-pdp__label">Save</span>');
    titleWrap.classList.add('avd-wl-title');
    titleWrap.appendChild(b);
  }

  /* ---------- wishlist page ---------- */
  function renderWishlistPage() {
    var mount = document.querySelector('[data-avd-wishlist]');
    if (!mount) return;
    var list = wlRead();
    if (!list.length) {
      mount.innerHTML = '<div class="avd-wlp__empty"><p>Your wishlist is empty.</p><p>Tap the heart on any product to save it here.</p><a class="button" href="/collections/all">Shop all</a></div>';
      return;
    }
    mount.innerHTML = '<p class="avd-wlp__count">' + list.length + ' saved</p><ul class="avd-wlp__grid" role="list"></ul>';
    var grid = mount.querySelector('.avd-wlp__grid');
    list.forEach(function (handle) {
      var li = document.createElement('li');
      li.className = 'avd-wlp__item';
      grid.appendChild(li);
      getProduct(handle).then(function (p) {
        var img = p.featured_image || '';
        var imgUrl = img ? img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=600' : '';
        li.innerHTML =
          '<a class="avd-wlp__link" href="' + p.url + '">' +
          '<div class="avd-wlp__media">' + (imgUrl ? '<img src="' + imgUrl + '" alt="" loading="lazy">' : '') + '</div>' +
          '<span class="avd-wlp__title"></span><span class="avd-wlp__price">' + money(p.price) + '</span></a>' +
          (p.available ? '' : '<span class="avd-wlp__soldout">Sold out</span>');
        li.querySelector('.avd-wlp__title').textContent = (p.title || '').replace(/^AVADACHI\s+/i, '');
        li.querySelector('.avd-wlp__media').appendChild(heartButton(handle, p.title, 'avd-ca__btn avd-ca__heart avd-wlp__heart'));
        wlSync();
      }).catch(function () {
        // product removed from the store: drop it from the list
        wlWrite(wlRead().filter(function (h) { return h !== handle; }));
        li.remove();
      });
    });
    wlSync();
  }


  /* ---------- homepage hero: blurred moving backdrop behind the vertical video (desktop) ---------- */
  function heroBackdrop() {
    if (window.innerWidth < 750) return;
    var hero = document.querySelector('.avd-refresh__hero--portrait');
    if (!hero) return;
    var bd = hero.querySelector('.avd-refresh__hero-backdrop');
    var v = hero.querySelector('.avd-refresh__hero-media video:not(.avd-hero-bgvid)');
    if (!bd || !v || bd.querySelector('video')) return;
    var c = v.cloneNode(true);
    c.removeAttribute('id');
    c.removeAttribute('controls');
    c.className = 'avd-hero-bgvid';
    c.muted = true;
    c.setAttribute('muted', '');
    c.setAttribute('aria-hidden', 'true');
    c.setAttribute('tabindex', '-1');
    bd.appendChild(c);
    var p = c.play(); if (p && p.catch) p.catch(function () {});
    // keep the blurred copy in step with the main video
    v.addEventListener('timeupdate', function () {
      if (Math.abs(c.currentTime - v.currentTime) > 0.35) c.currentTime = v.currentTime;
    });
    v.addEventListener('play', function () { var q = c.play(); if (q && q.catch) q.catch(function () {}); });
    v.addEventListener('pause', function () { c.pause(); });
  }

  /* ---------- init ---------- */
  function init() {
    headerHeart();
    productHeart();
    heroBackdrop();
    scanCards(document);
    renderWishlistPage();
    wlSync();

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.avd-ca__panel') && !e.target.closest('.avd-ca__bag')) closeAllPanels(null);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllPanels(null); });

    // wishlist page: re-render when a heart is un-ticked there
    document.addEventListener('click', function (e) {
      var h = e.target.closest('.avd-wlp__heart');
      if (h) setTimeout(renderWishlistPage, 150);
    });
    window.addEventListener('storage', function (e) { if (e.key === WL_KEY) wlSync(); });

    // grids re-render after filtering, sorting, infinite load and the cart drawer
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; scanCards(document); headerHeart(); wlSync(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
